<template>
  <div class="d-flex">
    <px-input-currency
      dense
      label="Valor inicial"
      class="required rounded-tag-small mr-1"
      @blur="onBlur"
      @change="onChange"
      v-bind="$attrs"
      v-model="valorInicial"/>
    <px-input-currency
      dense
      label="Valor final"
      class="required rounded-tag-small ml-1"
      @blur="onBlur"
      @change="onChange"
      v-bind="$attrs"
      v-model="valorFinal"/>
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
  },
  data() {
    return {
      valorInicial: null,
      valorFinal: null,
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value;
      },
      set(localValue) {
        this.$emit('input', localValue);
      },
    },
  },
  methods: {
    onBlur(event) {
      this.$emit('blur', event);
    },
    onChange() {
      if (this.valorInicial > this.valorFinal) {
        this.localValue = null;
        return;
      }
      if (this.valorInicial && this.valorFinal) {
        this.localValue = {
          valorInicial: this.valorInicial,
          valorFinal: this.valorFinal,
        };
        return;
      }
      this.localValue = null;
    },
  },
  created() {
    if (!this.value) {
      return;
    }
    this.localValue = {
      valorInicial: this.value.valorInicial,
      valorFinal: this.value.valorFinal,
    };
    this.valorInicial = this.value.valorInicial;
    this.valorFinal = this.value.valorFinal;
  },
};
</script>
